/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CrmProjectCategoryCountsData
 */
export interface CrmProjectCategoryCountsData {
    /**
     * 
     * @type {number}
     * @memberof CrmProjectCategoryCountsData
     */
    all?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CrmProjectCategoryCountsData
     */
    active?: number;
    /**
     * 
     * @type {number}
     * @memberof CrmProjectCategoryCountsData
     */
    inactive?: number;
    /**
     * 
     * @type {number}
     * @memberof CrmProjectCategoryCountsData
     */
    opportunity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CrmProjectCategoryCountsData
     */
    deleted?: number;
}

/**
 * Check if a given object implements the CrmProjectCategoryCountsData interface.
 */
export function instanceOfCrmProjectCategoryCountsData(value: object): value is CrmProjectCategoryCountsData {
    return true;
}

export function CrmProjectCategoryCountsDataFromJSON(json: any): CrmProjectCategoryCountsData {
    return CrmProjectCategoryCountsDataFromJSONTyped(json, false);
}

export function CrmProjectCategoryCountsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmProjectCategoryCountsData {
    if (json == null) {
        return json;
    }
    return {
        
        'all': json['all'] === undefined ? undefined : json['all'] === null ? null : json['all'],
        'active': json['active'] == null ? undefined : json['active'],
        'inactive': json['inactive'] == null ? undefined : json['inactive'],
        'opportunity': json['opportunity'] === undefined ? undefined : json['opportunity'] === null ? null : json['opportunity'],
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
    };
}

export function CrmProjectCategoryCountsDataToJSON(json: any): CrmProjectCategoryCountsData {
    return CrmProjectCategoryCountsDataToJSONTyped(json, false);
}

export function CrmProjectCategoryCountsDataToJSONTyped(value?: CrmProjectCategoryCountsData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'all': value['all'],
        'active': value['active'],
        'inactive': value['inactive'],
        'opportunity': value['opportunity'],
        'deleted': value['deleted'],
    };
}

